import { gql } from '@apollo/client';
import { FRAGMENT_ACCESS_GROUP } from './fragment.accessGroup';

export const FETCH_ACCESS_GROUPS_COMPANY = gql`
    ${FRAGMENT_ACCESS_GROUP}
    query fetchAccessGroupsCompany {
        company {
            accessGroups {
                ...accessGroup
            }
        }
    }
`;
